import React, { CSSProperties, PropsWithChildren } from 'react';

import InfoThickIcon from '@repo/ui/components/Icon/InfoThickIcon';
import { P2 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import { Box, FlipIcon } from './styles';

const ErrorBox: React.FC<PropsWithChildren & { styles?: CSSProperties }> = ({
  children,
  styles = {},
}) => {
  return (
    <Box style={styles}>
      <FlipIcon>
        <InfoThickIcon
          height="20px"
          theme={{ color: themeStyle.varAlertRed }}
        />
      </FlipIcon>
      <P2>{children}</P2>
    </Box>
  );
};

export default ErrorBox;
